import { axiosGet, axiosPost } from "../../react_axios/Axios";
import { GET_APPLICATION_MATRIX_LIST, UPDATE_SHORTLIST_FINALIST_MATRIX_LIST, getApplicationMatrixListUrl, updateShortlistFinalistMatrixUrl, user_id, award_event_id, headers, } from "../../utils/constants";


export const getApplicationMatrixList_action = (award_event_profile_id, Round) => async (dispatch) => {
    try {
        const params = {
            award_event_id: sessionStorage.getItem("award_event_id"),
            award_event_profile_id: award_event_profile_id,
            Round: Round,
        }

        const res = await axiosGet(getApplicationMatrixListUrl, params, headers)

        dispatch({
            type: GET_APPLICATION_MATRIX_LIST,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const updateShortlistFinalistMatrix_action = (award_event_profile_id, application_form_id, Mode, matrixList) => async (dispatch) => {
    try {
        const params = {
            user_id: sessionStorage.getItem("user_id"),
            award_event_id: sessionStorage.getItem("award_event_id"),
            award_event_profile_id: award_event_profile_id,
            application_form_id: application_form_id,
            Mode: Mode,
            matrixList: matrixList,
        }

        const res = await axiosPost(updateShortlistFinalistMatrixUrl, params, headers)

        dispatch({
            type: UPDATE_SHORTLIST_FINALIST_MATRIX_LIST,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}